import { combineReducers } from 'redux';

import forEach from 'lodash/forEach';
import union from 'lodash/union';
import uniq from 'lodash/uniq';

import * as types from '../types';
import { events } from './trackerNotifications';

const byId = (state = {}, action) => {
  switch (action.type) {
    // COMPLETED TYPES
    case types.USER_NOTIFICATIONS_FETCH_COMPLETED: {
      const { entities, order } = action.payload;
      const newState = {};
      order.forEach((notifId) => {
        newState[notifId] = {
          isSelected: false,
          ...entities[notifId],
          isConfirmed: true,
          shownAtLogin: false
        };
      });
      return newState;
    }

    case types.USER_NOTIFICATIONS_PARTIAL_FETCH_COMPLETED: {
      const { entities, order } = action.payload;
      const newState = { ...state };
      order.forEach((notifId) => {
        newState[notifId] = {
          isSelected: false,
          ...state[notifId],
          ...entities[notifId],
          isConfirmed: true,
          shownAtLogin: false
        };
      });
      return newState;
    }

    case types.USER_NOTIFICATION_READ_COMPLETED: {
      const { notifications, notificationIds } = action.payload;
      const newState = { ...state };
      notificationIds.forEach((notificationId, index) => {
        newState[notificationId] = {
          isSelected: false,
          ...notifications[index],
          isConfirmed: true,
          shownAtLogin: true
        };
      });
      return newState;
    }

    case types.USER_NOTIFICATION_READ_STARTED: {
      const notificationIds = action.payload;
      const newState = { ...state };
      notificationIds.forEach((notificationId) => {
        newState[notificationId] = {
          isSelected: false,
          ...newState[notificationId],
          status: 2,
          isConfirmed: false,
          shownAtLogin: true
        };
      });
      return newState;
    }

    case types.USER_NOTIFICATION_READ_FAILED: {
      const notificationIds = action.payload;
      const newState = { ...state };
      notificationIds.forEach((notificationId) => {
        newState[notificationId] = {
          isSelected: false,
          ...newState[notificationId],
          status: 1,
          isConfirmed: false,
          shownAtLogin: true
        };
      });
      return newState;
    }

    case types.SYSTEM_NOTIFICATION_READ_COMPLETED: {
      const { notifications, notificationIds } = action.payload;
      const newState = { ...state };
      notificationIds.forEach((notificationId, index) => {
        newState[notificationId] = {
          isSelected: false,
          ...notifications[index],
          isConfirmed: true,
          shownAtLogin: true
        };
      });
      return newState;
    }

    case types.SYSTEM_NOTIFICATION_READ_STARTED: {
      const notificationIds = action.payload;
      const newState = { ...state };
      notificationIds.forEach((notificationId) => {
        newState[notificationId] = {
          isSelected: false,
          ...newState[notificationId],
          status: 2,
          isConfirmed: false,
          shownAtLogin: true
        };
      });
      return newState;
    }

    case types.SYSTEM_NOTIFICATION_READ_FAILED: {
      const notificationIds = action.payload;
      const newState = { ...state };
      notificationIds.forEach((notificationId) => {
        newState[notificationId] = {
          isSelected: false,
          ...newState[notificationId],
          status: 1,
          isConfirmed: false,
          shownAtLogin: true
        };
      });
      return newState;
    }

    case types.USER_NOTIFICATION_FORWARD_COMPLETED: {
      const { notifications, notificationIds } = action.payload;
      const newState = { ...state };
      notificationIds.forEach((notificationId, index) => {
        newState[notificationId] = {
          isSelected: false,
          ...notifications[index],
          isConfirmed: true,
          shownAtLogin: true
        };
      });
      return newState;
    }

    case types.USER_NOTIFICATION_FORWARD_STARTED: {
      const notificationIds = action.payload;
      const newState = { ...state };
      notificationIds.forEach((notificationId) => {
        newState[notificationId] = {
          isSelected: false,
          ...newState[notificationId],
          isConfirmed: false,
          shownAtLogin: true
        };
      });
      return newState;
    }

    case types.USER_NOTIFICATION_FORWARD_FAILED: {
      const notificationIds = action.payload;
      const newState = { ...state };
      notificationIds.forEach((notificationId) => {
        newState[notificationId] = {
          isSelected: false,
          ...newState[notificationId],
          isConfirmed: false,
          shownAtLogin: true
        };
      });
      return newState;
    }

    case types.USER_NOTIFICATION_SHOWN: {
      const notificationId = action.payload;
      const newState = {
        ...state,
        [notificationId]: {
          ...state[notificationId],
          shownAtLogin: true
        }
      };
      return newState;
    }

    case types.USER_NOTIFICATION_SELECTED: {
      const notificationId = action.payload;
      const newState = {
        ...state,
        [notificationId]: {
          ...state[notificationId],
          isSelected: true
        }
      };
      return newState;
    }

    case types.USER_NOTIFICATION_DESELECTED: {
      const notificationId = action.payload;
      const newState = {
        ...state,
        [notificationId]: {
          ...state[notificationId],
          isSelected: false
        }
      };
      return newState;
    }

    case types.USER_NOTIFICATION_ALL_SELECTED: {
      const notificationIds = action.payload;
      const newState = { ...state };
      if (notificationIds.length == 0) {
        forEach(state, (notification: any, notificationId) => {
          newState[notificationId] = {
            ...notification,
            isSelected: true
          };
        });
      } else {
        notificationIds.forEach((notificationId) => {
          newState[notificationId] = {
            ...state[notificationId],
            isSelected: true
          };
        });
      }
      return newState;
    }

    case types.USER_NOTIFICATION_ALL_DESELECTED: {
      const notificationIds = action.payload;
      const newState = { ...state };
      if (notificationIds.length == 0) {
        forEach(state, (notification: any, notificationId) => {
          newState[notificationId] = {
            ...notification,
            isSelected: false
          };
        });
      } else {
        notificationIds.forEach((notificationId) => {
          newState[notificationId] = {
            ...state[notificationId],
            isSelected: false
          };
        });
      }
      return newState;
    }

    default: {
      return state;
    }
  }
};

const order = (state = [], action) => {
  switch (action.type) {
    case types.USER_NOTIFICATIONS_FETCH_COMPLETED: {
      const { order } = action.payload;
      return union(order);
    }

    case types.USER_NOTIFICATIONS_PARTIAL_FETCH_COMPLETED: {
      const { order } = action.payload;
      return uniq([...state, ...order]);
    }

    default: {
      return state;
    }
  }
};

// STATES TO KNOW IF IT IS FETCHING, ADDING  OR EDITING
const isFetchingList = (state = false, action) => {
  switch (action.type) {
    case types.USER_NOTIFICATIONS_FETCH_STARTED: {
      return true;
    }
    case types.USER_NOTIFICATIONS_FETCH_COMPLETED:
    case types.USER_NOTIFICATIONS_FETCH_FAILED: {
      return false;
    }
    default: {
      return state;
    }
  }
};

const isPartialFetchingList = (state = false, action) => {
  switch (action.type) {
    case types.USER_NOTIFICATIONS_PARTIAL_FETCH_STARTED: {
      return true;
    }
    case types.USER_NOTIFICATIONS_PARTIAL_FETCH_COMPLETED:
    case types.USER_NOTIFICATIONS_PARTIAL_FETCH_FAILED: {
      return false;
    }
    default: {
      return state;
    }
  }
};

const isMarkingAsRead = (state = false, action) => {
  switch (action.type) {
    case types.USER_NOTIFICATION_READ_STARTED: {
      return true;
    }
    case types.USER_NOTIFICATION_READ_COMPLETED:
    case types.USER_NOTIFICATION_READ_FAILED: {
      return false;
    }
    default: {
      return state;
    }
  }
};

const isMarkingSystemAsRead = (state = false, action) => {
  switch (action.type) {
    case types.SYSTEM_NOTIFICATION_READ_STARTED: {
      return true;
    }
    case types.SYSTEM_NOTIFICATION_READ_COMPLETED:
    case types.SYSTEM_NOTIFICATION_READ_FAILED: {
      return false;
    }
    default: {
      return state;
    }
  }
};

const isForwarding = (state = false, action) => {
  switch (action.type) {
    case types.USER_NOTIFICATION_FORWARD_STARTED: {
      return true;
    }
    case types.USER_NOTIFICATION_FORWARD_COMPLETED:
    case types.USER_NOTIFICATION_FORWARD_FAILED: {
      return false;
    }
    default: {
      return state;
    }
  }
};

const errorFetchingList = (state = null, action) => {
  switch (action.type) {
    case types.USER_NOTIFICATIONS_FETCH_FAILED: {
      const { error } = action.payload;
      return error;
    }
    case types.USER_NOTIFICATIONS_FETCH_STARTED:
    case types.USER_NOTIFICATIONS_FETCH_COMPLETED: {
      return null;
    }
    default: {
      return state;
    }
  }
};

const errorPartialFetchingList = (state = null, action) => {
  switch (action.type) {
    case types.USER_NOTIFICATIONS_PARTIAL_FETCH_FAILED: {
      const { error } = action.payload;
      return error;
    }
    case types.USER_NOTIFICATIONS_PARTIAL_FETCH_STARTED:
    case types.USER_NOTIFICATIONS_PARTIAL_FETCH_COMPLETED: {
      return null;
    }
    default: {
      return state;
    }
  }
};

const errorMarkingAsRead = (state = false, action) => {
  switch (action.type) {
    case types.USER_NOTIFICATION_READ_FAILED: {
      const { error } = action.payload;
      return error;
    }
    case types.USER_NOTIFICATION_READ_STARTED:
    case types.USER_NOTIFICATION_READ_COMPLETED: {
      return null;
    }
    default: {
      return state;
    }
  }
};

const errorMarkingSystemAsRead = (state = false, action) => {
  switch (action.type) {
    case types.SYSTEM_NOTIFICATION_READ_FAILED: {
      const { error } = action.payload;
      return error;
    }
    case types.SYSTEM_NOTIFICATION_READ_STARTED:
    case types.SYSTEM_NOTIFICATION_READ_COMPLETED: {
      return null;
    }
    default: {
      return state;
    }
  }
};

const errorForwarding = (state = false, action) => {
  switch (action.type) {
    case types.USER_NOTIFICATION_FORWARD_FAILED: {
      const { error } = action.payload;
      return error;
    }
    case types.USER_NOTIFICATION_FORWARD_STARTED:
    case types.USER_NOTIFICATION_FORWARD_COMPLETED: {
      return null;
    }
    default: {
      return state;
    }
  }
};

const notices = combineReducers({
  byId,
  order,
  isMarkingAsRead,
  isMarkingSystemAsRead,
  isForwarding,
  errorMarkingAsRead,
  errorMarkingSystemAsRead,
  errorForwarding
});

const userNotifications = combineReducers({
  notices,
  events,
  isFetchingList,
  isPartialFetchingList,
  errorFetchingList,
  errorPartialFetchingList
});

export default userNotifications;

export const getOwnState = (state) => state.userNotifications;

export const getEventsState = (state) => getOwnState(state).events;
export const getNoticesState = (state) => getOwnState(state).notices;

export const getUserNotices = (state, notificationId) =>
  getNoticesState(state).byId[notificationId];
export const getUserNoticeList = (state) =>
  getNoticesState(state).order.map((id) => getUserNotices(state, id));

export const getTotalCountUserNotifications = (state) =>
  getUserNoticeList(state).length + getUserEventList(state).length;

export const getUserEvent = (state, notificationId) => getEventsState(state).byId[notificationId];
export const getUserEventList = (state) =>
  getEventsState(state).order.map((id) => getUserEvent(state, id));

export const getSelectedUserNotices = (state) => {
  const selectedNotifications = getUserNoticeList(state).filter(
    (notification) => notification.isSelected
  );

  if (selectedNotifications.length === 0) return null;
  if (selectedNotifications.length > 0) return selectedNotifications;
};

export const getSelectedUserNotice = (state) => {
  const selectedNotifications = getUserNoticeList(state).filter((notification) => {
    return notification.isSelected;
  });
  if (selectedNotifications.length === 1) return selectedNotifications[0];
  else return null;
};

export const getPermanentUserNotices = (state) => {
  const permanentNotifications = getUserNoticeList(state).filter(
    (notification) => notification.showToast === 1 && notification.toastTime === 0
  );
  return permanentNotifications;
};

export const getUnreadUserNotices = (state) => {
  return getUserNoticeList(state).filter((notification) => notification.status === 1);
};

export const getReadUserNotices = (state) => {
  return getUserNoticeList(state).filter((notification) => notification.status === 2);
};

//Status of sags
export const isPartialFetchingListUserNotices = (state) => getOwnState(state).isPartialFetchingList;
export const isFetchingListUserNotifications = (state) => getOwnState(state).isFetchingList;
export const isMarkingAsReadUserNotice = (state) => getNoticesState(state).isMarkingAsRead;
export const isMarkingAsReadSystemNotice = (state) => getNoticesState(state).isMarkingSystemAsRead;
export const isForwardingUserNotice = (state) => getNoticesState(state).isForwarding;

//Errors
export const getFetchingListUserNoticesErrors = (state) => getOwnState(state).errorFetchingList;
export const getMarkAsReadErrors = (state) => getNoticesState(state).errorMarkingAsRead;
export const getMarkSystemAsReadErrors = (state) => getNoticesState(state).errorMarkingSystemAsRead;
export const getForwardingErrors = (state) => getNoticesState(state).errorForwarding;
